// Change background on scroll
const handleMobileLogoDisplay = () => {
    const opacityClass = 'opacity-0';
    const maxWidthClass = 'logo-small';
    const scrollTrigger = document.querySelector('.hero').clientHeight * 0.75;
    const lgBreakpoint = 992;

    console.log(scrollTrigger);

    // Hide logo when scrolling below hero image
    if (window.innerWidth <= lgBreakpoint) {
        if (window.scrollY >= scrollTrigger) {
            document.querySelector('.logo').classList.add(opacityClass);
        } else {
            document.querySelector('.logo').classList.remove(opacityClass);
        }
    } else {
        document.querySelector('.logo').classList.remove(opacityClass);

        if (window.scrollY >= scrollTrigger) {
            document.querySelector('.logo-lg').classList.add(maxWidthClass);
        } else {
            document.querySelector('.logo-lg').classList.remove(maxWidthClass);
        }
    }
};

window.addEventListener('scroll', function () {
    console.log('scroll');
    handleMobileLogoDisplay();
});

window.addEventListener('resize', function () {
    console.log('resize');
    handleMobileLogoDisplay();
});
